import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Card, Radio, Alert, message } from "antd";
import { req_edit_tqa_reviewCheck, req_add_tqa_reviewCheck } from "../../api";

class ReviewSchoolCheckModal extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  static propTypes = {
    worker: PropTypes.object.isRequired,
    checkdata: PropTypes.object.isRequired,
  };
  state = {
    worker: {},
    checkdata: {},
    questions: [
      "一、院及系所依據基本素養及核心能力訂定學生學習成效檢核方式及落實情形。",
      "二、院及系所能依據評量結果修訂課程內容。",
      "三、院及系所提升學生實務能力之具體措施。",
      "四、院及系所符合完整之發展與回饋機制。",
      "五、其他有關增進學生學習意願及提升學習成效之具體做法。",
    ],
    options: [
      { label: "非常符合", value: "非常符合" },
      { label: "符合", value: "符合" },
      { label: "普通", value: "普通" },
      { label: "不符合", value: "不符合" },
      { label: "非常不符合", value: "非常不符合" },
    ],
  };

  UNSAFE_componentWillMount() {
    this.init();
  }

  // 遠端數據處理 //////////////////////////////////////////////
  api_modify_item = async (item) => {
    const { token } = this.props.user;
    //console.log(item);
    item.condition = "BASE";
    const result = await req_edit_tqa_reviewCheck(item, token);
    if (result.status === "success") {
      message.success(result.message);
    } else {
      message.error(result.message);
    }
  };

  api_add_item = async (item) => {
    const { token } = this.props.user;
    //console.log(item);
    const result = await req_add_tqa_reviewCheck(item, token);
    if (result.status === "success") {
      message.success(result.message);
    } else {
      message.error(result.message);
    }
  };
  // 數據配置設定 //////////////////////////////////////////////

  init = () => {
    // console.log(this.props.bulletinboard)
    const worker = this.props.worker;
    const checkdata = this.props.checkdata;
    this.setState({ worker, checkdata });
  };

  onRadioChange = (tag, { target: { value } }) => {
    // console.log(value);
    const { checkdata } = this.state;
    // console.log(event)
    Object.keys(checkdata).forEach((propertyName) => {
      if (tag === propertyName) {
        checkdata[propertyName] = value;
      }
    });
    this.setState({ checkdata });
  };

  onButtonChange = () => {
    const { checkdata } = this.state;
    //console.log(checkdata);

    checkdata.RecordStatus === "NEWDATA"
      ? this.api_add_item(checkdata)
      : this.api_modify_item(checkdata);
  };
  render() {
    const { options, questions } = this.state;
    const {
      ChoicedValueA,
      ChoicedValueB,
      ChoicedValueC,
      ChoicedValueD,
      ChoicedValueE,
      RecordStatus,
    } = this.props.checkdata;
    //console.log("checkdata:", this.props.checkdata);
    //console.log("worker:", this.props.worker);
    return (
      <Card
        title="檢核內容"
        bordered={false}
        style={{
          width: "100%",
        }}
      >
        <Alert message={questions[0]} type="info" showIcon />
        <p></p>
        <Radio.Group
          options={options}
          onChange={(e) => this.onRadioChange("ChoicedValueA", e)}
          defaultValue={ChoicedValueA}
        />
        <p></p>
        <Alert message={questions[1]} type="info" showIcon />
        <p></p>
        <Radio.Group
          options={options}
          onChange={(e) => this.onRadioChange("ChoicedValueB", e)}
          defaultValue={ChoicedValueB}
        />
        <p></p>
        <Alert message={questions[2]} type="info" showIcon />
        <p></p>
        <Radio.Group
          options={options}
          onChange={(e) => this.onRadioChange("ChoicedValueC", e)}
          defaultValue={ChoicedValueC}
        />
        <p></p>
        <Alert message={questions[3]} type="info" showIcon />
        <p></p>
        <Radio.Group
          options={options}
          onChange={(e) => this.onRadioChange("ChoicedValueD", e)}
          defaultValue={ChoicedValueD}
        />
        <p></p>
        <Alert message={questions[4]} type="info" showIcon />
        <p></p>
        <Radio.Group
          options={options}
          onChange={(e) => this.onRadioChange("ChoicedValueE", e)}
          defaultValue={ChoicedValueE}
        />
        <div style={{ textAlign: "right" }}>
          {RecordStatus === "SUBMIT" ? (
            ""
          ) : (
            <button className="btn btn-danger" onClick={this.onButtonChange}>
              {RecordStatus === "NEWDATA" ? "送出" : "修改"}
            </button>
          )}
        </div>
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(ReviewSchoolCheckModal);
